<form
  *ngIf="!collapsed"
  [formGroup]="form"
  [class.valid]="form.valid || form.disabled"
>
  <div class="title flex vcenter">
    <span *ngIf="file.value" class="grow1">
      {{ index + 1 }}. {{ "CASE_FORM.FORMS.CLAIMS.CLAIM.TITLE" | translate }}
    </span>
    <span *ngIf="!file.value" class="grow1" color="blue-king">
      {{ "CASE_FORM.FORMS.CLAIMS.CLAIM.UPLOAD_PROMPT" | translate }}
    </span>
    <mat-progress-spinner
      *ngIf="invoiceLoading"
      diameter="24"
      mode="indeterminate"
    ></mat-progress-spinner>
    <button
      *ngIf="isDeleteable"
      payee-icon-button
      color="white"
      (click)="deleteClaim()"
    >
      <payee-icon name="trash-red"></payee-icon>
    </button>
    <button
      [disabled]="!form.valid"
      payee-icon-button
      class="collapse-button"
      color="white"
      (click)="collapsed = true"
    >
      <payee-icon name="collapse"></payee-icon>
    </button>
  </div>

  <section *ngIf="!file.value">
    <payee-dropzone
      class="file-upload"
      title=""
      [description]="
        'CASE_FORM.FORMS.CLAIMS.CLAIM.UPLOAD_DESCRIPTION' | translate
      "
      [multiple]="false"
      (dropped)="fileDropped($event)"
    ></payee-dropzone>
  </section>

  <section *ngIf="file.value" class="flex vcenter uploaded-file">
    <payee-icon name="upload-paper" class="file-icon"></payee-icon>
    <a
      *ngIf="isFileUploaded"
      class="file-name"
      [href]="file.value?.storage_url"
      target="_blank"
    >
      {{ file.value?.file_name }}
    </a>
    <span *ngIf="!isFileUploaded" class="file-name">
      {{ file.value?.name }}
    </span>
    <button
      *ngIf="isEditable || !isFileUploaded"
      payee-icon-button
      color="white"
      (click)="file.patchValue(null)"
    >
      <payee-icon name="trash-red"></payee-icon>
    </button>
  </section>

  <div *ngIf="file.invalid && file.dirty" color="alert-red">
    <span *ngIf="file.hasError('required')">
      {{ "ERROR_MESSAGES.FILE_REQUIRED" | translate }}
    </span>
    <span *ngIf="file.hasError('unknown')">{{ file.errors.unknown }}</span>
  </div>

  <div class="top-margin-15">
    <payee-form-field>
      <span payee-label>
        {{ "CASE_FORM.FORMS.CLAIMS.CLAIM.AMOUNT_LABEL" | translate }}
      </span>
      <span payee-suffix>
        {{ currency_iso }}
      </span>
      <input payee-input formControlName="original_amount" />
      <ng-container
        payee-error
        *ngIf="original_amount.invalid && original_amount.dirty"
      >
        <span *ngIf="original_amount.hasError('required')">
          {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
        </span>
        <span *ngIf="original_amount.hasError('max')">
          {{
            "CASE_FORM.FORMS.CLAIMS.CLAIM.ERRORS.MAX_AMOUNT"
              | translate
                : {
                    max: original_amount.errors.max.max | number : "1.0" : "hu",
                    currency: currency_iso
                  }
          }}
        </span>
        <span *ngIf="original_amount.hasError('unknown')">{{
          original_amount.errors.unknown
        }}</span>
      </ng-container>
    </payee-form-field>
  </div>

  <div class="top-margin-15">
    <payee-form-field>
      <span payee-label>
        {{ "CASE_FORM.FORMS.CLAIMS.CLAIM.DUE_DATE_LABEL" | translate }}
      </span>
      <payee-datepicker
        formControlName="due_date_at"
        [max]="maxDueDate"
      ></payee-datepicker>
      <ng-container
        payee-error
        *ngIf="due_date_at.invalid && due_date_at.dirty"
      >
        <span *ngIf="due_date_at.hasError('required')">
          {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
        </span>
        <span *ngIf="due_date_at.hasError('max')">
          {{
            "CASE_FORM.FORMS.CLAIMS.CLAIM.ERRORS.DUE_DATE_EXCEEDED" | translate
          }}
        </span>
        <span *ngIf="due_date_at.hasError('unknown')">{{
          due_date_at.errors.unknown
        }}</span>
      </ng-container>
    </payee-form-field>
  </div>
</form>
<div
  *ngIf="collapsed"
  class="claim-summary flex vcenter top-margin-15"
  (click)="collapsed = false"
>
  <payee-icon name="checkmark-darker-green-circle"></payee-icon>
  <div class="claim-data flex column grow1">
    <div *ngIf="isFileUploaded">
      {{ file.value?.file_name }}
    </div>
    <div *ngIf="!isFileUploaded">
      {{ file.value?.name }}
    </div>
    <div>
      {{ original_amount.value | number : "1.0" : "hu" }} {{ currency_iso }}
    </div>
    <div>{{ due_date_at.value | date : "yyyy.MM.dd." }}</div>
  </div>
  <payee-icon name="expand"></payee-icon>
</div>
